import { JobCardAction, JobCardActionTypes } from './job-card.actions';

export const JOB_CARD_FEATURE_KEY = 'jobCard';

/**
 * Interface for the 'JobCard' data used in
 *  - JobCardState, and the reducer function
 *
 *  Note: replace if already defined in another module
 */

/* tslint:disable:no-empty-interface */
export interface IJobCard {
  id: string;
  companyName: string;
  jobNo: string;
  impExp: string;
  mode: string;
  airlineName: string;
  masterBLNo: string;
  masterAWBNo: string;
  houseBLNo: string;
  houseAWBNo: string;
  AWBDate: Date;
  AWBId: string;
  shipperName: string;
  shipperAddress01: string;
  shipperAddress02: string;
  shipperAddress03: string;
  shipperAddress04: string;
  consigneeName: string;
  consigneeAddress01: string;
  consigneeAddress02: string;
  consigneeAddress03: string;
  consigneeAddress04: string;
  notifyName: string;
  notifyAddress01: string;
  notifyAddress02: string;
  notifyAddress03: string;
  notifyAddress04: string;
  deliveryAgentName: string;
  deliveryAgentAddress01: string;
  deliveryAgentAddress02: string;
  deliveryAgentAddress03: string;
  deliveryAgentAddress04: string;
  placeOfReceipt: string;
  portOfLoading: string;
  EtdAtPortOfLoading: string;
  portOfDischarge: string;
  finalPlaceOfDelivery: string;
  EtaAtPortOfDischarge: string;
  vesselVoy: string;
  bookingAgentName: string;
  bookingAgentAddress: string;
  marksAndNumbers: string;
  containerNo: string[];
  lineSealNo: string;
  customSealNo: string;
  typeOfContainer: string;
  description: string;
  netWeight: string;
  grossWeight: string;
  measurement: string;
  chaName: string;
  checkListNo: string;
  checkListDate: Date;
  shippingBillNo: string;
  shippingBillDate: Date;
  coLoader: string;
  stuffingDate: Date;
  noOfPackages: string;
  pallet: string;
  palletNo: string;
  certificate: string;
  otherCertificateName: string;
  insurance: Boolean;
  transportation: Boolean;
  specialInstructions: string;
  status: string;
  editable: boolean;
  accountId: string;
  RequestedDate: string;
  closeAt: any;
  closeBy: string;
  cancelAt: any;
  cancelBy: String;
  createdAt: any;
  updatedAt: any;
  owner: string;
}

export interface JobCardState {
  list: IJobCard[]; // list of JobCard; analogous to a sql normalized table
  selectedId?: string | number; // which JobCard record has been selected
  loaded: boolean; // has the JobCard list been loaded
  error?: any; // last none error (if any)
  selectedJobCard?: any;
  loading?: boolean;
  updateJobLoading?: boolean;
  loadFilesLoading?: boolean;
  nextJobNo?: any;
  files?: any[];
  fileProgress?: any;
  stuffingDetails?: { description: string; name: string };
  loadingConfirmationDetails?: { description: string; name: string };
  tvtBLDetails?: {
    blType: string;
    blNoTitle: string;
    blNo: string;
    typeOfMove?: string;
    sob?: string;
    sobDate?: any;
    printDate: any;
  };
  eglBLDetails?: {
    blType: string;
    scac?: string;
    amsNo?: string;
    blNoTitle: string;
    blNo: string;
    typeOfMove?: string;
    sob?: string;
    sobDate?: any;
    printDate: any;
  };
  awbDetails?: any;
  logoUrl?: any;
  acdDetails?: any;
}

export interface JobCardPartialState {
  readonly [JOB_CARD_FEATURE_KEY]: JobCardState;
}

export const initialState: JobCardState = {
  list: [],
  loaded: false,
};

export function reducer(
  state: JobCardState = initialState,
  action: JobCardAction
): JobCardState {
  switch (action.type) {
    case JobCardActionTypes.JobCardLoaded: {
      state = {
        ...state,
        list: action.payload,
        loaded: true,
      };
      break;
    }
    case JobCardActionTypes.JobCardLoadError: {
      state = {
        ...state,
        error: action.payload,
      };
      break;
    }
    case JobCardActionTypes.SelectedJobCardLoaded: {
      state = {
        ...state,
        selectedJobCard: action.payload,
      };
      break;
    }
    case JobCardActionTypes.SelectedJobCardLoadError: {
      state = {
        ...state,
        error: action.payload,
      };
      break;
    }
    case JobCardActionTypes.CreateJobCard: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case JobCardActionTypes.CreateJobCardError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case JobCardActionTypes.JobCardCreated: {
      state = {
        ...state,
        loading: false,
        list: [...state.list, action.payload],
      };
      break;
    }
    case JobCardActionTypes.NextJobNoUpdated: {
      state = {
        ...state,
        nextJobNo: action.payload,
      };
      break;
    }
    case JobCardActionTypes.NextJobNoUpdatedError: {
      state = {
        ...state,
        error: action.payload,
      };
      break;
    }
    case JobCardActionTypes.NextJobNoLoaded: {
      state = {
        ...state,
        nextJobNo: action.payload,
      };
      break;
    }
    case JobCardActionTypes.LoadNextJobNoError: {
      state = {
        ...state,
        error: action.payload,
      };
      break;
    }
    case JobCardActionTypes.UpdateJObCard: {
      state = {
        ...state,
        loading: true,
        updateJobLoading: true,
      };
      break;
    }
    case JobCardActionTypes.JobCardUpdated: {
      state = {
        ...state,
        loading: false,
        updateJobLoading: false,
      };
      break;
    }
    case JobCardActionTypes.UpdateJobCardError: {
      state = {
        ...state,
        loading: false,
        updateJobLoading: false,
        error: action.payload,
      };
      break;
    }
    case JobCardActionTypes.SaveStuffingDetails: {
      state = {
        ...state,
        stuffingDetails: action.payload,
      };
      break;
    }
    case JobCardActionTypes.SaveLoadingConfirmationDetails: {
      state = {
        ...state,
        loadingConfirmationDetails: action.payload,
      };
      break;
    }
    case JobCardActionTypes.SaveTVTBLDetails: {
      state = {
        ...state,
        tvtBLDetails: action.payload,
      };
      break;
    }
    case JobCardActionTypes.SaveEGLBLDetails: {
      state = {
        ...state,
        eglBLDetails: action.payload,
      };
      break;
    }
    case JobCardActionTypes.AWBDetailsLoaded: {
      state = {
        ...state,
        awbDetails: action.payload,
      };
      break;
    }
    case JobCardActionTypes.AWBDetailsUpdated: {
      state = {
        ...state,
        awbDetails: action.payload,
      };
      break;
    }
    case JobCardActionTypes.SaveACDDetails: {
      state = {
        ...state,
        acdDetails: action.payload,
      };
      break;
    }
    case JobCardActionTypes.UploadFiles: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case JobCardActionTypes.FilesUploaded: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
    case JobCardActionTypes.FileUploadError: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
    case JobCardActionTypes.LoadFiles: {
      state = {
        ...state,
        loadFilesLoading: true,
      };
      break;
    }
    case JobCardActionTypes.FilesLoaded: {
      state = {
        ...state,
        loadFilesLoading: false,
        files: action.files,
      };
      break;
    }
    case JobCardActionTypes.FilesLoadError: {
      state = {
        ...state,
        loadFilesLoading: false,
      };
      break;
    }
    case JobCardActionTypes.FilesProgress: {
      state = {
        ...state,
        fileProgress: action.payload,
      };
      break;
    }
  }
  return state;
}
